/**
 * Ora di split tra fascia MATTINA e POMERIGGIO per prenotazioni daily (barche/escursioni).
 *
 * Fonte unica: prima era hardcoded '13:00'/13 separatamente in lib/season-slot-price.ts,
 * lib/boat-busy.ts e app/api/excursions/[id]/available-dates/route.ts — cambiarla
 * richiedeva toccare 3 file in sync. Vedi [[project_boat_span_pricing]].
 */
export const DAY_PART_SPLIT_HOUR = 13;
export const DAY_PART_SPLIT_HHMM = '13:00';
